/** @file A refused batch or history request: the error text, Retry (batches only) and Dismiss. */
import type { CommandCall } from '@pose2d/format/types';
import { dispatch } from '../../api/sync/dispatch';
import { pushNotice } from '../../api/sync/pushNotice';
import { errorText } from '../../shell/i18n/errorText';
import { useT } from '../../shell/i18n/useT';
import { liveStore, type LiveNotice } from '../../stores/liveStore';
import { Button } from '../../ui-kit/Button';

/** Retry re-dispatches the batch (a new refusal leaves a new notice). */
export function NoticeRow({ notice }: { notice: LiveNotice }) {
  const t = useT();
  const dismiss = (): void => {
    liveStore.setState((s) => ({ notices: s.notices.filter((n) => n.id !== notice.id) }));
  };
  const retry = (calls: CommandCall[]): void => {
    dismiss();
    try {
      dispatch(calls).done.catch(() => undefined);
    } catch (thrown) {
      pushNotice(calls, thrown);
    }
  };
  const { calls } = notice;
  return (
    <div role="alert" className="activity-notice">
      <p>{errorText(t, { pose2d: notice.error })}</p>
      {calls === null ? null : <Button label={t('activity.retry')} onClick={() => { retry(calls); }} />}
      <Button label={t('activity.dismiss')} onClick={dismiss} />
    </div>
  );
}
